module.exports = __webpack_public_path__ + "img/for-men-5.59683cd.webp";